import React, { useState } from 'react';
import { ModalConfirmationWithErrorAndLoader } from '../common/ModalConfirmationWithErrorAndLoader';
import { TFreelancerData } from '../../types';
import { capitalizeFirstLetter, getErrorMessages } from '../../utils';
import { executeHttpRequest } from '../../epics/api';


type TEnableDisableProps = {
    freelancerData: TFreelancerData;
    setFreelancerData: (data: TFreelancerData) => void;
    notification?: any;
    isOpen: boolean;
    setIsOpen: (isOpen: boolean) => void;
}

export default function EnableDisable({
    freelancerData,
    setFreelancerData,
    notification,
    isOpen,
    setIsOpen,
}: TEnableDisableProps) {
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);

    const mode = freelancerData.is_active ? 'disable' : 'enable';
    const title = `${capitalizeFirstLetter(mode)} Worker`;

    const handleClose = () => setIsOpen(false);

    const handleContinue = () => {
        setIsLoading(true);
        setError(null);

        executeHttpRequest(`freelancers/${freelancerData.id}/${mode}/`, 'post')
            .then(response => {
                setIsLoading(false);
                setFreelancerData(response.data.content);
                handleClose();
                notification?.success('Success', `Successfully ${mode}d ${freelancerData.full_name}.`);
            })
            .catch(err => {
                setIsLoading(false);
                setError(getErrorMessages(err));
            });
    };

    return (
        <ModalConfirmationWithErrorAndLoader
            className={null}
            errorMessage={error}
            handleCancel={handleClose}
            handleContinue={handleContinue}
            isError={!!error}
            isInProgress={isLoading}
            setIsInProgress={setIsLoading}
            isOpen={isOpen}
            title={title}
            continueButtonText="CONTINUE"
        >
            <p className="modal-title">{title}</p>

            <p>Are you sure you would like to {mode} this worker?</p>
            <p className="margin-top-10">
                {mode === 'disable'
                    ? 'They will not be able to use the mobile app, or register again using ' +
                      'the same email address or mobile number'
                    : 'They will have the ability to use the mobile app again and receive communications from us'
                }
            </p>
        </ModalConfirmationWithErrorAndLoader>
    );
}
